import React from "react";
import { useNavigate } from "react-router-dom";
import imageLogo from "../../images/logo.png";
import GradesDetails from "../../Components/GradesDetails/GradesDetails";
import GradesTable from "../../Components/GradesTable/GradesTable";
import GPASection from "../../Components/GPASection/GPASection";

const Grades = ({ data = [], grades = [], gpa = [] }) => {
  const navigate = useNavigate();

  const handleSignout = () => {
    navigate("/");
  };

  console.log("pandey", grades, gpa);

  return (
    <div>
      <div className="mt-4">
        <div className="d-flex justify-content-between">
          <div style={{ width: "200px", height: "200px" }}>
            <img
              style={{ width: "100%", height: "100%" }}
              src={imageLogo}
              alt="logo"
            />
          </div>
          <div>
            <p style={{ fontSize: "44px", fontWeight: "bold" }}>TRANSCRIPT</p>
          </div>
          <div className="" style={{ borderRadius: "18px", padding: "18px" }}>
            <div>
              <button
                style={{
                  borderRadius: "8px",
                  padding: "8px",
                  fontSize: "16px",
                }}
                onClick={handleSignout}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
        <GradesDetails data={data} />
        <GradesTable data={data} grades={grades} />
        <GPASection data={data} gpa={gpa} />
      </div>
    </div>
  );
};

export default Grades;

// {/* {data &&
//   data[0] &&
//   Object.entries(
//     data.filter((item) => item?.t1key110 === idGrade)[0]
//   ).map(([key, value]) => (
//     <div>
//       <p>
//         {studentGrouping[key] !== "null" && itemTitle[key]}{" "}
//         {studentGrouping[key] !== "null" && ":"}{" "}
//         {studentGrouping[key] !== "null" && value.toString()}
//         {studentGrouping[key] !== "null" &&
//           (!isEditing ? (
//             value.toString()
//           ) : (
//             <input
//               name={{}}
//               type="text"
//               onChange={handleInputChange(key, studentGrouping)}
//             ></input>
//           ))}
//       </p>
//     </div>
//   ))} */}

//  {/* 120 */}
//  <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item120}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1]?.t1item120?.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item120}
//          name="t1item120"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item120 ? item.t1item120 : formValues?.t1item120}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 130 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item130}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item130.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item130}
//          name="t1item130"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item130 ? item.t1item130 : formValues?.t1item130}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 140 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item140}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item140.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item140}
//          name="t1item140"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item140 ? item.t1item140 : formValues?.t1item140}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 150 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item150}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item150.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item150}
//          name="t1item150"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item150 ? item.t1item150 : formValues?.t1item150}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 160 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item160}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item160.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item160}
//          name="t1item160"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item160 ? item.t1item160 : formValues?.t1item160}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 170 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item170}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item170.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item170}
//          name="t1item170"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item170 ? item.t1item170 : formValues?.t1item170}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 180 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item180}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item180.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item180}
//          name="t1item180"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item180 ? item.t1item180 : formValues?.t1item180}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 190 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item190}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item190.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item190}
//          name="t1item190"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item190 ? item.t1item190 : formValues?.t1item190}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 200 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item200}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item200.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item120}
//          name="t1item200"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item200 ? item.t1item200 : formValues?.t1item200}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 210 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item210}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item210.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item210}
//          name="t1item210"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item210 ? item.t1item210 : formValues?.t1item210}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 220 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item220}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item220.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item220}
//          name="t1item220"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item220 ? item.t1item220 : formValues?.t1item220}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 230 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item230}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item230.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item230}
//          name="t1item230"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item230 ? item.t1item230 : formValues?.t1item230}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 240 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item240}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item240.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item240}
//          name="t1item240"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item240 ? item.t1item240 : formValues?.t1item240}
//        </div>
//      )}
//    </>
//  ))}
// </div>
// {/* 250 */}
// <div className="d-flex">
//  {data && studentGrouping && (
//    <strong>{data[0]?.t1item250}:&nbsp;</strong>
//  )}
//  {studentDetail.map((item) => (
//    <>
//      {data[1].t1item250.includes("editable") && isEditing ? (
//        <input
//          type="text"
//          value={formValues?.t1item250}
//          name="t1item250"
//          onChange={(e) => handleInputChange(e, item.t1key110)}
//          // placeholder="edit"
//        ></input>
//      ) : (
//        <div>
//          {item.t1item250 ? item.t1item250 : formValues?.t1item250}
//        </div>
//      )}
//    </>
//  ))}
// </div>
